let currentFeatures: string[] = [];

export function setActiveFeatures(features: string[]) {
  currentFeatures = features;
}

export function getActiveFeatures() {
  return currentFeatures;
}
